import { useState } from "react";
import { checkQrCode } from "../services/qrService";

export default function QRControl() {
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [qrCode, setQrCode] = useState('');
    const [qrData, setQrData] = useState(null);

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            const response = await checkQrCode(qrCode);
            setQrData(response);
        } catch (error) {
            setError(error.message || 'QR kod kontrolü sırasında bir hata oluştu.');
            setQrData(null);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
            <form onSubmit={handleSubmit} className="login-form" style={{
                marginBottom: '30px'
            }}>
                {error && <div className="error-message" style={{
                    marginBottom: '10px'
                }}>{error === 'Not found' ? 'QR kod bulunamadı' : error}</div>}
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="QR Kodu"
                        value={qrCode}
                        maxLength={12}
                        onChange={(e) => setQrCode(e.target.value)}
                        disabled={isLoading}
                        style={{
                            padding: '10px',
                            fontSize: '16px',
                            width: '100%',
                            marginBottom: '10px',
                            borderRadius: '4px',
                            border: '1px solid #ccc'
                        }}
                    />
                </div>
                <button
                    type="submit"
                    className="login-button"
                    disabled={isLoading}
                    style={{
                        padding: '10px 20px',
                        fontSize: '16px',
                        backgroundColor: '#18964e',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        width: '100%'
                    }}
                >
                    QR Kontrol Et
                </button>
            </form>
            {qrData && (
                <div className="qr-data-container" style={{
                    backgroundColor: '#f8f9fa',
                    padding: '20px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    <div className="data-section" style={{ marginBottom: '20px' }}>
                        <h2 style={{
                            color: '#333',
                            borderBottom: '2px solid #18964e',
                            paddingBottom: '10px',
                            marginBottom: '15px'
                        }}>Personel Bilgileri</h2>
                        <div className="data-row" style={{
                            display: 'flex',
                            marginBottom: '10px'
                        }}>
                            <span className="label" style={{
                                fontWeight: 'bold',
                                minWidth: '150px'
                            }}>Poşet Veren Personel:</span>
                            <span className="value">{qrData.personelAlinan || '-'}</span>
                        </div>
                        <div className="data-row" style={{
                            display: 'flex',
                            marginBottom: '10px'
                        }}>
                            <span className="label" style={{
                                fontWeight: 'bold',
                                minWidth: '150px'
                            }}>Atık Alan Personel:</span>
                            <span className="value">{qrData.personelVerilen || '-'}</span>
                        </div>
                    </div>

                    <div className="data-section" style={{ marginBottom: '20px' }}>
                        <h2 style={{
                            color: '#333',
                            borderBottom: '2px solid #18964e',
                            paddingBottom: '10px',
                            marginBottom: '15px'
                        }}>Adres Bilgileri</h2>
                        <div className="data-row" style={{
                            display: 'flex',
                            marginBottom: '15px',
                            padding: '10px',
                            backgroundColor: '#fff',
                            borderRadius: '4px'
                        }}>
                            <span className="label" style={{
                                fontWeight: 'bold',
                                minWidth: '150px'
                            }}>Tam Adres:</span>
                            <span className="value">{qrData.address}</span>
                        </div>
                        <div className="address-details" style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                            gap: '10px'
                        }}>
                            <div className="data-row" style={{
                                display: 'flex',
                                padding: '8px',
                                backgroundColor: '#fff',
                                borderRadius: '4px'
                            }}>
                                <span className="label" style={{
                                    fontWeight: 'bold',
                                    minWidth: '100px'
                                }}>Mahalle:</span>
                                <span className="value">{qrData.mahalle}</span>
                            </div>
                            <div className="data-row" style={{
                                display: 'flex',
                                padding: '8px',
                                backgroundColor: '#fff',
                                borderRadius: '4px'
                            }}>
                                <span className="label" style={{
                                    fontWeight: 'bold',
                                    minWidth: '100px'
                                }}>Sokak:</span>
                                <span className="value">{qrData.sokak}</span>
                            </div>
                            <div className="data-row" style={{
                                display: 'flex',
                                padding: '8px',
                                backgroundColor: '#fff',
                                borderRadius: '4px'
                            }}>
                                <span className="label" style={{
                                    fontWeight: 'bold',
                                    minWidth: '100px'
                                }}>Apartman No:</span>
                                <span className="value">{qrData.apartman}</span>
                            </div>
                            <div className="data-row" style={{
                                display: 'flex',
                                padding: '8px',
                                backgroundColor: '#fff',
                                borderRadius: '4px'
                            }}>
                                <span className="label" style={{
                                    fontWeight: 'bold',
                                    minWidth: '100px'
                                }}>Daire:</span>
                                <span className="value">{qrData.daire}</span>
                            </div>
                            <div className="data-row" style={{
                                display: 'flex',
                                padding: '8px',
                                backgroundColor: '#fff',
                                borderRadius: '4px'
                            }}>
                                <span className="label" style={{
                                    fontWeight: 'bold',
                                    minWidth: '100px'
                                }}>İlçe:</span>
                                <span className="value">{qrData.ilce}</span>
                            </div>
                        </div>
                    </div>

                    <div className="data-section">
                        <h2 style={{
                            color: '#333',
                            borderBottom: '2px solid #18964e',
                            paddingBottom: '10px',
                            marginBottom: '15px'
                        }}>İlave Bilgiler</h2>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                            gap: '10px'
                        }}>
                            <div className="data-row" style={{
                                display: 'flex',
                                padding: '8px',
                                backgroundColor: '#fff',
                                borderRadius: '4px'
                            }}>
                                <span className="label" style={{
                                    fontWeight: 'bold',
                                    minWidth: '120px'
                                }}>Onay Durumu:</span>
                                <span className="value">{qrData.onay || '-'}</span>
                            </div>
                            <div className="data-row" style={{
                                display: 'flex',
                                padding: '8px',
                                backgroundColor: '#fff',
                                borderRadius: '4px'
                            }}>
                                <span className="label" style={{
                                    fontWeight: 'bold',
                                    minWidth: '120px'
                                }}>Verilme Tarihi:</span>
                                <span className="value">
                                    {qrData.dateGiven ? new Date(qrData.dateGiven).toLocaleString('tr-TR') : '-'}
                                </span>
                            </div>
                            <div className="data-row" style={{
                                display: 'flex',
                                padding: '8px',
                                backgroundColor: '#fff',
                                borderRadius: '4px'
                            }}>
                                <span className="label" style={{
                                    fontWeight: 'bold',
                                    minWidth: '120px'
                                }}>Alınma Tarihi:</span>
                                <span className="value">
                                    {qrData.dateReceived ? new Date(qrData.dateReceived).toLocaleString('tr-TR') : '-'}
                                </span>
                            </div>
                        </div>
                        {qrData.description && (
                            <div className="data-row" style={{
                                display: 'flex',
                                marginTop: '10px',
                                padding: '8px',
                                backgroundColor: '#fff',
                                borderRadius: '4px'
                            }}>
                                <span className="label" style={{
                                    fontWeight: 'bold',
                                    minWidth: '120px'
                                }}>Açıklama:</span>
                                <span className="value">{qrData.description}</span>
                            </div>
                        )}
                    </div>
                    <div className="data-section">
                    <div className="data-row" style={{
                                display: 'flex',
                                padding: '8px',
                                backgroundColor: '#fff',
                                borderTop: '2px solid #18964e',
                                marginTop: '10px',
                                marginBottom: '10px'
                            }}>
                                <span className="value">{qrData.blockDescription || '-'} {qrData.blockOptionDesc || '-'}</span>
                            </div> 
                    </div>
                </div>
            )}
        </div>
    );
}
